import { Type, type Static } from '@sinclair/typebox';

export const HostedAuthVerifiedDomainSchema = Type.Object(
  {
    domain: Type.String(),
    enabled: Type.Boolean(),
  },
  { additionalProperties: false },
);

export const ListHostedAuthVerifiedDomainsResponseSchema = Type.Object(
  {
    domains: Type.Array(HostedAuthVerifiedDomainSchema),
  },
  { additionalProperties: false },
);

export const HostedAuthDomainResponseSchema = Type.Object(
  {
    success: Type.Literal(true),
    domain: Type.String(),
  },
  { additionalProperties: false },
);

export const DisableHostedAuthDomainForApplicationResponseSchema = Type.Object(
  {
    success: Type.Boolean(),
  },
  { additionalProperties: false },
);

export type HostedAuthVerifiedDomain = Static<typeof HostedAuthVerifiedDomainSchema>;
export type ListHostedAuthVerifiedDomainsResponse = Static<typeof ListHostedAuthVerifiedDomainsResponseSchema>;
export type HostedAuthDomainResponse = Static<typeof HostedAuthDomainResponseSchema>;
export type DisableHostedAuthDomainForApplicationResponse = Static<typeof DisableHostedAuthDomainForApplicationResponseSchema>;
